import React, { Component, Fragment } from 'react'
import { ApolloConsumer } from 'react-apollo'

import helpers from '../../helpers'

import { USERNAME_QUERY } from '../../queries'

import { Container, Header, FormContainer, ButtonContainer, StyledLink, Feedback, Message } from './styles'
import { white, red, almostblack, lightgray } from '../../styles/colors'

import Input from '../../components/Input/'
import Password from '../../components/Input/Password'
import Button from '../../components/Button/'
import CheckBox from '../../components/CheckBox/'
import PasswordIndicator from '../../components/PasswordIndicator/'

class LoginForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      secondPassword: '',
      stayLoggedIn: '',
      usernameValid: '',
      passwordStrength: {
        minimal: '',
        strength: 0
      }
    }

    this.checkForUsername = this.checkForUsername.bind(this)
  }

  componentDidMount() {
    this.timer = null
  }

  async checkForUsername() {
    if (this.state.username !== '') {
      const { data } = await this.client.query({
        query: USERNAME_QUERY,
        variables: { username: this.state.username }
      })
      if (data.usernameExists || this.state.username.length < 4) {
        if (data.usernameExists) {
          this.setState({ usernameValid: 'Gebruikersnaam is bezet' })
        } else {
          this.setState({ usernameValid: 'Gebruikersnaam moet minimaal 4 tekens bevatten' })
        }
      } else {
        this.setState({ usernameValid: 'true' })
      }
    }
  }

  handleChange(e) {
    if (this.props.activate) {
      if (e.target.name === 'username') {
        clearTimeout(this.timer)
        this.setState({ username: e.target.value, usernameValid: '' })
        this.timer = setTimeout(this.checkForUsername, 1000)
      } else if (e.target.name === 'password') {
        this.setState({
          password: e.target.value,
          passwordStrength: helpers.calculatePasswordStrenght(e.target.value)
        })
      } else if (e.target.name === 'second_password') {
        this.setState({ secondPassword: e.target.value })
      }
    } else {
      e.target.name === 'username'
        ? this.setState({ username: e.target.value })
        : this.setState({ password: e.target.value })
    }
  }

  handleClick(e) {
    this.state.stayLoggedIn === 'checked'
      ? this.setState({ stayLoggedIn: '' })
      : this.setState({ stayLoggedIn: 'checked' })
  }

  handleSubmit(e) {
    e.preventDefault()
    if (this.props.activate) {
      if (
        this.state.passwordStrength.minimal &&
        this.state.usernameValid &&
        this.state.password === this.state.secondPassword
      ) {
        this.props.login(this.state.username, this.state.password)
      }
    } else {
      this.props.login(this.state.username, this.state.password, this.state.stayLoggedIn)
    }
  }

  render() {
    const { activate } = this.props
    return (
      <ApolloConsumer>
        {client => {
          this.client = client
          return (
            <Container>
              <Header>{activate ? 'Activeren' : 'Inloggen'}</Header>
              <FormContainer onSubmit={this.handleSubmit.bind(this)}>
                <Input
                  value={this.state.username}
                  handleChange={this.handleChange.bind(this)}
                  name='username'
                  type='text'
                  placeholder='Gebruikersnaam'
                  icon='mail'
                  valid={this.state.usernameValid === '' || this.state.usernameValid === 'true'}
                />
                {this.state.usernameValid === '' || this.state.usernameValid === 'true' ? null : (
                  <Feedback>{this.state.usernameValid}</Feedback>
                )}
                <Password
                  value={this.state.password}
                  handleChange={this.handleChange.bind(this)}
                  type='password'
                  name='password'
                  placeholder='Wachtwoord'
                  icon='lock'
                  valid={this.state.passwordStrength.minimal}
                />
                {this.state.passwordStrength.minimal && activate ? (
                  <Password
                    value={this.state.secondPassword}
                    handleChange={this.handleChange.bind(this)}
                    type='password'
                    name='second_password'
                    placeholder='Wachtwoord bevestigen'
                    icon='lock'
                    valid={this.state.password === this.state.secondPassword}
                  />
                ) : null}
                {(activate && !this.props.activationId) || !activate ? (
                  <Message>
                    Nog geen account? Mail dan naar <a href='mailto:portal@kaarskoffie.nl'>portal@kaarskoffie.nl</a>
                  </Message>
                ) : null}
                {activate ? (
                  <Fragment>
                    {this.state.passwordStrength.minimal ? (
                      <Fragment>
                        {this.state.secondPassword !== '' && this.state.password !== this.state.secondPassword ? (
                          <Feedback>Wachtwoorden komen niet overeen</Feedback>
                        ) : (
                          <PasswordIndicator passwordStrength={this.state.passwordStrength} />
                        )}
                      </Fragment>
                    ) : this.state.passwordStrength.minimal === false ? (
                      <Feedback>Nog minimaal {10 - this.state.password.length} tekens toevoegen.</Feedback>
                    ) : null}
                  </Fragment>
                ) : null}
                {!activate ? (
                  <Fragment>
                    {this.props.loading ? (
                      <Feedback>Laden...</Feedback>
                    ) : (
                      <Feedback>{this.props.feedback ? this.props.feedback : ''}</Feedback>
                    )}
                  </Fragment>
                ) : null}
                {activate ? null : (
                  <CheckBox
                    value={this.state.stayLoggedIn}
                    handleChange={this.handleClick.bind(this)}
                    name='stayloggedin'
                  >
                    Ingelogd blijven
                  </CheckBox>
                )}
                <ButtonContainer>
                  {activate ? (
                    <Button
                      background={
                        this.state.passwordStrength.minimal &&
                        this.state.usernameValid &&
                        this.state.password === this.state.secondPassword
                          ? red
                          : lightgray
                      }
                      color={white}
                      radius='true'
                      hover={
                        this.state.passwordStrength.minimal &&
                        this.state.usernameValid &&
                        this.state.password === this.state.secondPassword
                          ? almostblack
                          : lightgray
                      }
                      onSubmit={this.handleSubmit.bind(this)}
                    >
                      Activeren
                    </Button>
                  ) : (
                    <Button
                      background={red}
                      color={white}
                      radius='true'
                      hover={almostblack}
                      onSubmit={this.handleSubmit.bind(this)}
                    >
                      Inloggen
                    </Button>
                  )}
                  {activate ? null : <StyledLink href='/wachtwoord-vergeten'>Wachtwoord vergeten?</StyledLink>}
                </ButtonContainer>
              </FormContainer>
            </Container>
          )
        }}
      </ApolloConsumer>
    )
  }
}

export default LoginForm



// WEBPACK FOOTER //
// ./src/containers/LoginForm/index.js